import * as Yup from 'yup'

export const ProductSchema = Yup.object().shape({
  name: Yup.string().required('This field is required'),
  brand: Yup.string().nullable(),
})
